import { useMemo } from 'react';
import { useAppContext } from '@provider/app-context';
import { useComponentEntry } from '@utils/component-framework';

function useBacklinkUrl(entryKey) {
  const isEmbedded = useAppContext(state => !!state.product);
  const learningObjectId = useComponentEntry(entryKey, {
    select: data => data?.learningObject?.id
  });
  const backlink = useMemo(() => {
    try {
      const externalBacklink = typeof location !== "undefined" ? new URLSearchParams(location.search).get("backlinkUrl") ?? undefined : undefined;
      if (externalBacklink) {
        return new URL(externalBacklink, location.href);
      } else if (isEmbedded) {
        const backlinkUrl = new URL(location.href);
        if (learningObjectId.data) {
          backlinkUrl.hash = learningObjectId.data;
        }
        return backlinkUrl;
      }
    } catch (err) {
      console.error(err);
    }
  }, [isEmbedded, learningObjectId.data]);
  return backlink;
}

export { useBacklinkUrl };
//# sourceMappingURL=hook.backlink-url.js.map
